import { getMarketDetail } from './getMarketDetail';
import { getMarketBanner } from './getMarketBanner';
import { getMarketGoodsCarousel } from './getMarketGoodsCarousel';
import { getMarketHomeGoods } from './getMarketHomeGoods';
import { getMarketAiStudioProductInfo } from './getMarketAiStudioProductInfo';
import { getMarketCouponList } from './getMarketCouponList';
import { postRedeemAllMarketCoupon } from './postRedeemAllMarketCoupon';
import { getMarketParent } from './getMarketParent';
import { getMarketParentHomeGoods } from './getMarketParentHomeGoods';
import { getMarketParentGoodsCarousel } from './getMarketParentGoodsCarousel';
import { getMarketParentCategories } from './getMarketParentCategories';

export const marketService = {
  getMarketDetail: getMarketDetail,
  getMarketBanner: getMarketBanner,
  getMarketCarousel: getMarketGoodsCarousel,
  getMarketHomeGoods,
  getMarketAiStudioProductInfo,
  getMarketCouponList,
  postRedeemAllMarketCoupon,
  getMarketParent,
  getMarketParentHomeGoods,
  getMarketParentGoodsCarousel,
  getMarketParentCategories,
};
